import React, { FC } from 'react';
import { Hyperlink } from './Hyperlink';
import { isUrlInternal } from '../utils/url-utils/urlUtils';
import { useUser } from '../user/useUser';
import { useRestrictedModal } from './modal/useRestrictedModal';

type Props = {
  className?: string;
  url: string;
  source: string;
  children: React.ReactNode;
};

export const HyperlinkRestrictedBaseModal: FC<Props> = ({
  className,
  url,
  source,
  children,
}) => {
  const { accessPremium, currentUser } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  return (
    <Hyperlink
      className={className}
      // We have the whitelist so we can show all links to snapshots
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(accessPremium || currentUser.isSnapshotsCrawler
        ? {
            href: url,
            source: isUrlInternal(url) ? source : '',
          }
        : {
            onClick: () => openRestrictedModal({ source }),
          })}
    >
      {children}
    </Hyperlink>
  );
};
